/* Il cuore sulla piastrella.

   Ricorda nel browser di chi guarda, e in nessun altro posto: nessun account,
   nessuna chiamata, niente che esca dalla pagina. E' quanto basta perche' il
   comando non sia finto — un cuore che si accende e dimentica al primo
   ricaricamento sarebbe peggio di un cuore assente.

   Fa tre cose, e la prima e' l'unica che c'era all'inizio:

     1. accende e spegne i cuori sulle piastrelle, ovunque siano;
     2. scopre il cuore nella barra in testa quando l'elenco non e' vuoto, e ne
        aggiorna il numero. Il collegamento nasce `hidden` nel markup: il
        server non puo' sapere cosa c'e' nel browser di chi guarda, quindi la
        pagina parte senza ingresso e lo fa comparire questo file;
     3. sulla pagina dei preferiti riempie la griglia, chiedendo al negozio una
        piastrella per ogni handle salvato.

   Se `localStorage` non e' disponibile — finestra anonima, dati di sito
   bloccati — l'accesso solleva un'eccezione al primo tentativo, non restituisce
   vuoto. Ogni lettura e ogni scrittura sono quindi protette, e nel caso
   peggiore il cuore funziona per la durata della visita. */

(function () {
  'use strict';

  var CHIAVE = 'vdm-preferiti';
  var USCITA = 200; // deve combaciare con la transizione di section-vdm-preferiti.css

  function leggi() {
    try {
      var grezzo = window.localStorage.getItem(CHIAVE);
      var elenco = grezzo ? JSON.parse(grezzo) : [];
      return Array.isArray(elenco) ? elenco : [];
    } catch (e) {
      return [];
    }
  }

  function scrivi(elenco) {
    try {
      window.localStorage.setItem(CHIAVE, JSON.stringify(elenco));
    } catch (e) {
      /* Quota piena o archiviazione negata: la visita continua lo stesso. */
    }
  }

  function dipingi(bottone, acceso) {
    bottone.setAttribute('aria-pressed', acceso ? 'true' : 'false');
    var etichetta = acceso
      ? bottone.getAttribute('data-etichetta-togli')
      : bottone.getAttribute('data-etichetta-aggiungi');
    if (etichetta) bottone.setAttribute('aria-label', etichetta);
  }

  function allinea(radice) {
    var elenco = leggi();
    var bottoni = (radice || document).querySelectorAll('[data-vdm-preferito]');
    for (var i = 0; i < bottoni.length; i++) {
      dipingi(bottoni[i], elenco.indexOf(bottoni[i].getAttribute('data-vdm-preferito')) > -1);
    }
  }

  /* Il cuore nella barra c'e' sempre: e' una porta, e una porta che compare e
     scompare non si impara. Quello che appare solo quando ha senso e' il
     numero: una pastiglia a zero in cima alla pagina sarebbe un invito a
     riempirla, cioe' pressione. */
  function ingresso(elenco) {
    var porta = document.querySelector('[data-vdm-preferiti-ingresso]');
    if (!porta) return;
    var conto = porta.querySelector('[data-vdm-preferiti-conto]');
    if (!conto) return;
    conto.textContent = elenco.length;
    conto.hidden = elenco.length === 0;
  }

  /* Sulla pagina dei preferiti il cuore spento non lascia una piastrella accesa
     a meta': la porta via. Se era l'ultima, torna lo stato vuoto — quello vero,
     quello gia' scritto in pagina, non una frase costruita qui. */
  function pota(elenco) {
    var griglia = document.querySelector('[data-vdm-preferiti-griglia]');
    if (!griglia) return;

    var bottoni = griglia.querySelectorAll('[data-vdm-preferito]');
    for (var i = 0; i < bottoni.length; i++) {
      if (elenco.indexOf(bottoni[i].getAttribute('data-vdm-preferito')) > -1) continue;
      var piastrella = bottoni[i].closest('.vdm-piastrella');
      if (!piastrella || piastrella.dataset.vdmEsce) continue;
      piastrella.dataset.vdmEsce = '1';
      piastrella.classList.add('e-esce');
      /* Il nodo esce dal documento a transizione finita, non subito: toglierlo
         sull'istante salterebbe la dissolvenza, e chi ha sbagliato cuore non
         vedrebbe *quale* scarpa se n'e' andata. */
      setTimeout(
        (function (nodo) {
          return function () {
            nodo.remove();
            vuoto(griglia);
          };
        })(piastrella),
        USCITA
      );
    }
  }

  function vuoto(griglia) {
    var stato = document.querySelector('[data-vdm-preferiti-vuoto]');
    if (stato) stato.hidden = griglia.children.length > 0;
  }

  /* Riempie la griglia. Una richiesta per handle, tutte insieme, e ognuna torna
     la piastrella vera renderizzata dal negozio.

     I posti si creano prima e in ordine, poi ciascuno viene sostituito dalla
     sua piastrella quando arriva: le risposte tornano nell'ordine che decide la
     rete, e senza i posti l'elenco si rimescolerebbe a ogni caricamento.

     L'ordine e' dal piu' recente al piu' vecchio. L'elenco cresce in fondo, e
     chi apre la pagina cerca quello che ha appena messo da parte. */
  function riempi() {
    var griglia = document.querySelector('[data-vdm-preferiti-griglia]');
    if (!griglia || !window.fetch) return;

    var elenco = leggi().slice().reverse();
    if (!elenco.length) return;

    vuoto(griglia);

    elenco.forEach(function (handle) {
      var posto = document.createElement('div');
      posto.className = 'vdm-preferiti__posto';
      griglia.appendChild(posto);

      fetch('/products/' + encodeURIComponent(handle) + '?view=piastrella', {
        credentials: 'same-origin'
      })
        .then(function (risposta) {
          if (!risposta.ok) throw new Error(risposta.status);
          return risposta.text();
        })
        .then(function (html) {
          var contenitore = document.createElement('div');
          contenitore.innerHTML = html.trim();
          var piastrella = contenitore.firstElementChild;
          if (!piastrella) throw new Error('vuoto');
          posto.replaceWith(piastrella);
          allinea(piastrella);
          vuoto(griglia);
        })
        .catch(function () {
          /* Prodotto tolto dal catalogo o non piu' pubblicato. Esce dal posto e
             dall'elenco: tenerlo vorrebbe dire un buco che riprova a ogni
             visita, e chi guarda non ha modo di capire cosa manca. */
          posto.remove();
          dimentica(handle);
          vuoto(griglia);
        });
    });
  }

  function dimentica(handle) {
    var elenco = leggi();
    var dove = elenco.indexOf(handle);
    if (dove === -1) return;
    elenco.splice(dove, 1);
    scrivi(elenco);
    ingresso(elenco);
  }

  /* Delegato sul documento: la griglia della collezione si ricostruisce a ogni
     filtro con la Section Rendering API, e un ascoltatore per bottone sarebbe
     rimasto attaccato ai nodi buttati via. */
  document.addEventListener('click', function (evento) {
    var bottone = evento.target.closest && evento.target.closest('[data-vdm-preferito]');
    if (!bottone) return;
    evento.preventDefault();

    var handle = bottone.getAttribute('data-vdm-preferito');
    var elenco = leggi();
    var dove = elenco.indexOf(handle);
    if (dove > -1) elenco.splice(dove, 1);
    else elenco.push(handle);
    scrivi(elenco);

    /* Tutte le occorrenze, non solo quella toccata: lo stesso prodotto puo'
       comparire in novita' e nei correlati sulla stessa pagina, e due cuori
       diversi per la stessa scarpa sono un difetto visibile. */
    allinea(document);
    ingresso(elenco);
    pota(elenco);
  });

  /* La griglia filtrata arriva dopo, e i suoi cuori nascono tutti spenti. */
  if (window.MutationObserver) {
    new MutationObserver(function (mutazioni) {
      for (var i = 0; i < mutazioni.length; i++) {
        if (mutazioni[i].addedNodes.length) {
          allinea(document);
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function avvia() {
    allinea(document);
    ingresso(leggi());
    riempi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
